module.exports = __webpack_public_path__ + "e5c839ece95de146a176b318738261bf.svg";